import { render, staticRenderFns } from "./CreditRequestAuthDetails.vue?vue&type=template&id=56e20676&scoped=true&"
import script from "./CreditRequestAuthDetails.vue?vue&type=script&lang=js&"
export * from "./CreditRequestAuthDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreditRequestAuthDetails.vue?vue&type=style&index=0&id=56e20676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e20676",
  null
  
)

export default component.exports